
import { useEffect, useState } from "react";
import { Menu, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MyListingCard from "./myListingCard";
import SellerConfirmed from "./SellerConfirmed";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { getUserInfo } from "../../apis/General/users";
import { useSelector } from "react-redux";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";
import Web3 from "web3";

export default function MyListings({ itemsPerPage, currentPage, setCurrentPage }) {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [listing, setListing] = useState([]);
  const [anchorElFour, setAnchorElFour] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [actionType, setActionType] = useState(""); // "pause", "resume", "delete"
  const [account, setAccount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const openerFour = Boolean(anchorElFour);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [pauseOpen, setPauseOpen] = useState(false);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          alert(
            "Please allow access to your MetaMask wallet to enable you exchange your CCRT"
          );
          console.error("User denied account access", err);
        });
    } else {
      console.error(
        "MetaMask is not installed. Please install it to use this app."
      );
    }
  }, []);

  const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";
  const contractABI = EnergySharingContract.abi;

  useEffect(() => {
    if (web3) {
      const contractInstance = new web3.eth.Contract(contractABI, contractAddress);
      setContract(contractInstance);
    }
  }, [web3]);

  const handleGetAllListings = async (page = 1) => {
    try {
      const offset = (page - 1) * itemsPerPage;
      console.log("Fetching my listings for MY LISTINGS tab...");

      if (!account) {
        console.error("No wallet connected. Please connect your MetaMask wallet.");
        return;
      }

      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      console.log("Fetching listings for seller:", account);
      const { listings, totalCount } = await integration.getSellerListings(
        account,
        offset,
        itemsPerPage
      );

      console.log("Raw listings from blockchain:", listings);
      console.log("Total count:", totalCount);

      // Create a new array before reversing
      const reversedListings = listings ? [...listings].reverse() : [];
      console.log("Processed listings:", reversedListings);

      setListing(reversedListings);
      console.log("State should be updated now");
      setTotalItems(Number(totalCount));

    } catch (error) {
      console.error("Failed to fetch my listings:", error);
    }
  };

  useEffect(() => {
    if (account) {
      handleGetAllListings(currentPage);
    }
  }, [account, currentPage]);

  const handleCloseFour = () => {
    setAnchorElFour(null);
    setSelectedListing(null);
  };

  const handleClickFour = (event, listingItem) => {
    setAnchorElFour(event.currentTarget);
    setSelectedListing(listingItem);
  };

  const getListingStatus = (statusCode) => {
    switch (statusCode) {
      case 0:
        return "in-progress";
      case 1:
        return "paused";
      default:
        return "pending";
    }
  };

  const handleListingAction = async () => {
    console.log("handleListingAction called with:", {
      selectedListing,
      actionType
    });

    if (!selectedListing) {
      alert("No listing selected");
      return;
    }

    setLoading(true);
    try {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      switch (actionType) {
        case "pause":
          await integration.pauseListing(selectedListing.listingId);
          alert("Listing paused successfully");
          break;
        case "resume":
          await integration.resumeListing(selectedListing.listingId);
          alert("Listing resumed successfully");
          break;
        case "delete":
          await integration.cancelListing(selectedListing.listingId);
          alert("Listing deleted successfully");
          break;
        default:
          alert("Invalid action");
          return;
      }

      // Refresh listings after successful action
      await handleGetAllListings();

    } catch (error) {
      console.error(`Failed to ${actionType} listing:`, error);
      alert(`Failed to ${actionType} listing: ${error.message}`);
    } finally {
      setLoading(false);
      // Close modals and clear state
      setOpen(false);
      setDeleteOpen(false);
      setPauseOpen(false);
      setSelectedListing(null);
      setActionType("");
    }
  };

  // Cancel button functions
  const handleCancelAction = () => {
    setOpen(false);
    setSelectedListing(null);
    setActionType("");
  };

  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setSelectedListing(null);
    setActionType("");
  };

  const handlePauseClick = () => {
    console.log("Pause clicked, selectedListing:", selectedListing);
    setActionType("pause");
    setOpen(true);
    setAnchorElFour(null); // Just close the menu
  };

  const handleResumeClick = () => {
    console.log("Resume clicked, selectedListing:", selectedListing);
    setActionType("resume");
    setOpen(true);
    setAnchorElFour(null); // Just close the menu
  };

  const handleDeleteClick = () => {
    console.log("Delete clicked, selectedListing:", selectedListing);
    setActionType("delete");
    setDeleteOpen(true);
    setAnchorElFour(null); // Just close the menu
  };

  const handleEditClick = () => {
    if (selectedListing) {
      navigate(`/edit-listing/${selectedListing.listingId}`);
      window.scrollTo(0, 0);
    }
    handleCloseFour();
  };

  useEffect(() => {
    handleGetAllListings();
  }, []);

  const getActionTitle = () => {
    switch (actionType) {
      case "pause":
        return "Pause Listing";
      case "resume":
        return "Resume Listing";
      case "delete":
        return "Delete Listing";
      default:
        return "Confirm Action";
    }
  };

  const getActionSubtitle = () => {
    // Debug: log the selectedListing to see the actual structure
    console.log("Selected listing in getActionSubtitle:", selectedListing);

    // Use the quantity property since you confirmed it exists
    const energyAmount = selectedListing?.quantity || 0;

    console.log("Energy amount:", energyAmount);

    switch (actionType) {
      case "pause":
        return `You want to pause your listing to sell ${energyAmount}kWh of energy. If you didn't initiate this action click cancel.`;
      case "resume":
        return `You want to resume your listing to sell ${energyAmount}kWh of energy. If you didn't initiate this action click cancel.`;
      case "delete":
        return `You want to delete your listing to sell ${energyAmount}kWh of energy. This action cannot be undone. If you didn't initiate this action click cancel.`;
      default:
        return "Are you sure you want to perform this action?";
    }
  };

  const getActionButtonText = () => {
    switch (actionType) {
      case "pause":
        return ["Cancel", "Pause listing"];
      case "resume":
        return ["Cancel", "Resume listing"];
      case "delete":
        return ["Cancel", "Delete listing"];
      default:
        return ["Cancel", "Confirm"];
    }
  };

  const Pagination = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);


    return (
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };


  return (
    <>
      <table className="energyOrders__inner__card__table">
        <tbody>
          {listing?.map((listingItem) => (
            <MyListingCard
              listing={listingItem}
              key={listingItem?.listingId}
              status={getListingStatus(listingItem?.status)}
              handleClickFour={(event) => handleClickFour(event, listingItem)}
            />
          ))}
        </tbody>

        <Menu
          id="basic-menu"
          anchorEl={anchorElFour}
          open={openerFour}
          onClose={handleCloseFour}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            sx={{
              width: "18.4rem",
              fontSize: "1.4rem",
              fontFamily: "Inter",
              fontWeight: "500",
              backgroundColor: "#fff !important",
              "&:hover": {
                color: "#063",
                backgroundColor: "#fff",
              },
            }}
            className="subMenu"
            onClick={handleEditClick}
          >
            Edit
          </MenuItem>

          {/* Show Pause if listing is in-progress (status 0 or pending  'default') */}
          {(selectedListing?.status === 0 || selectedListing?.status === 'default') && (
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",
                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={handlePauseClick}
            >
              Pause
            </MenuItem>
          )}

          {/* Show Resume if listing is paused (status 1) */}
          {selectedListing?.status === 1 && (
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",
                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={handleResumeClick}
            >
              Resume
            </MenuItem>
          )}

          <MenuItem
            sx={{
              width: "18.4rem",
              fontSize: "1.4rem",
              fontFamily: "Inter",
              fontWeight: "500",
              backgroundColor: "#fff !important",
              "&:hover": {
                color: "#063",
                backgroundColor: "#fff",
              },
            }}
            className="subMenu"
            onClick={handleDeleteClick}
          >
            Delete
          </MenuItem>
        </Menu>
      </table>
      <Pagination />
      {/* Modal for Pause/Resume actions */}
      <SellerConfirmed
        title={getActionTitle()}
        subtitle={getActionSubtitle()}
        buttonTexts={getActionButtonText()}
        buttonFunctions={[
          handleCancelAction,
          handleListingAction
        ]}
        open={open}
        setOpen={setOpen}
      />

      {/* Modal for Delete action */}
      <SellerConfirmed
        title={getActionTitle()}
        subtitle={getActionSubtitle()}
        buttonTexts={getActionButtonText()}
        buttonFunctions={[
          handleCancelDelete,
          handleListingAction
        ]}
        open={deleteOpen}
        setOpen={setDeleteOpen}
      />
    </>
  );
}